<template>
  <div class="w100 bg-w pt20 pb20 pl20 pr20" v-loading="loading">
    <div class="w100 cl-f">
      <span class="font-16">办事指南</span>
      <div class="fr flex-box">
        <el-input class="mr10" placeholder="查询" prefix-icon="el-icon-search" v-model="searchText" @keyup.enter.native="initPage" clearable></el-input>
        <el-button type="primary" size="mini" @click="initPage">查询</el-button>
        <el-button type="success" size="mini" @click="uploadFile">新增指南</el-button>
      </div>
    </div>

    <div class="w100 po-r pt20">
      <el-table class="w100 tx-c my-table" :data="list" stripe border>
        <el-table-column align="center" label="序号" width="60px">
          <template slot-scope="scope">
            {{ (pageNum - 1) * pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column header-align="center" label="标题" prop="title"></el-table-column>
        <el-table-column align="center" label="发布机构" prop="publishingBody" width="240px"></el-table-column>
        <el-table-column align="center" label="发布时间" width="150px">
          <template slot-scope="scope">
            {{ scope.row.releaseTime | filterDate('yyyy-MM-dd hh:mm') }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="100px">
          <template slot-scope="scope">
            <span class="blue cu-p" @click="download(scope.row)">下载</span>
            <span class="ml10 red cu-p" @click="deleteItem(scope.row)">删除</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="w100 mt20 tx-r">
        <el-pagination @size-change="changeSize" @current-change="changePage" :current-page="pageNum" :page-sizes="[10, 20, 30, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" background :total="total"></el-pagination>
      </div>
    </div>
    <a class="none" ref="downloadExcel" :href="downloadUrl"></a>
    <Upload ref="uploadView" @onSuccess="initPage" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import Upload from "@/components/Public/Upload";

export default {
  name: "WordList",
  components: { Upload },
  props: [],
  data() {
    return {

      loading: false,
      searchText: "",

      pageNum: 1,
      pageSize: 20,
      total: 0,
      list: [],

      downloadUrl: ""
    };
  },
  computed: {
    ...mapState(["userToken"])
  },
  mounted() {
    this.initPage();
  },
  methods: {
    fetchList() {
      this.loading = true;
      this.$http
        .post(
          `bizGuide/query`,
          this.$qs.stringify({
            processDefId: this.$route.params.id,
            queryKey: this.searchText,
            pageNum: this.pageNum,
            pageSize: this.pageSize
          })
        )
        .then(({ data }) => {
          // console.log(data);
          if (data.resCode == "0") {
            this.list = data.resData.list;
            this.total = data.resData.total;
            this.loading = false;
          } else {
            this.$notify({
              title: "错误",
              message: data.resMsg,
              type: "error",
              offset: 60
            });
            this.loading = false;
          }
        })
        .catch(() => {
          this.$notify({
            title: "错误",
            message: "页面请求错误，请检查网络",
            type: "error",
            offset: 60
          });
          this.loading = false;
        });
    },
    deleteItem(item) {
      // console.log(item);
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.loading = true;
          this.$http
            .post(`bizGuide/delete`, this.$qs.stringify({ id: item.id }))
            .then(({ data }) => {
              // console.log(data);
              if (data.RetCode) {
                this.$message.success("删除成功");
                this.fetchList();
              } else {
                this.$message.error(data.RetMsg);
                this.loading = false;
              }
            })
            .catch(() => {
              this.$message.error("页面请求错误，请检查网络");
              this.loading = false;
            });
        })
        .catch(() => {});
    },
    initPage() {
      this.pageNum = 1;
      this.list = [];
      this.fetchList();
    },
    changeSize(value) {
      this.pageSize = value;
      this.fetchList();
    },
    changePage(value) {
      this.pageNum = value;
      this.fetchList();
    },
    download(item) {
      this.downloadUrl = item.download + "&sid=" + this.userToken;
      this.$nextTick(() => {
        this.$refs.downloadExcel.click();
      });
    },
    uploadFile() {
      this.$refs.uploadView.showView(`bizGuide/fileUpload`, "file", {
        processDefId: this.$route.params.id
      });
    }
  }
};
</script>

<style scoped>
.serve-app {
  width: 180px;
  height: 120px;
  padding: 15px 0 0 0;
  border-radius: 4px;
  box-shadow: 2px 2px 4px #ccc;
}
</style>
